import axiosInstance from "../api/axios";

const M = "/material";

/* ---------------- Categories (self-referential tree; a sub-category has a parent) ---------------- */
export const searchCategories = (body) =>
  axiosInstance.post(`${M}/categories/search`, { withAttributes: true, pageSize: 200, ...body });
export const getCategory = (id) => axiosInstance.get(`${M}/categories/${id}?with_attributes=true`);
export const createCategory = (body) => axiosInstance.post(`${M}/categories`, body);
export const updateCategory = (id, body) => axiosInstance.put(`${M}/categories/${id}`, body);
export const deleteCategory = (id) => axiosInstance.delete(`${M}/categories/${id}`);
export const deleteCategoryAttribute = (categoryId, attributeId) =>
  axiosInstance.delete(`${M}/categories/${categoryId}/attributes/${attributeId}`);

/* ---------------- Brands ---------------- */
export const searchBrands = (body) => axiosInstance.post(`${M}/brands/search`, { pageSize: 200, ...body });
export const getBrand = (id) => axiosInstance.get(`${M}/brands/${id}?with_categories=true`);
export const getBrandsByCategory = (categoryId) => axiosInstance.get(`${M}/brands/by-category/${categoryId}`);
export const createBrand = (body) => axiosInstance.post(`${M}/brands`, body);
export const updateBrand = (id, body) => axiosInstance.put(`${M}/brands/${id}`, body);
export const deleteBrand = (id) => axiosInstance.delete(`${M}/brands/${id}`);
// Get-or-create a brand by name + ensure it is linked to the category (inline combobox add).
export const quickCreateBrand = (body) => axiosInstance.post(`${M}/brands/quick`, body);

/* ---------------- Vendors ---------------- */
export const searchVendors = (body) => axiosInstance.post(`${M}/vendors/search`, { pageSize: 200, ...body });
// Vendor detail — returns nested `subcategories[].brands[]` coverage.
export const getVendor = (id) => axiosInstance.get(`${M}/vendors/${id}`);
export const createVendor = (body) => axiosInstance.post(`${M}/vendors`, body);
export const updateVendor = (id, body) => axiosInstance.put(`${M}/vendors/${id}`, body);
export const deleteVendor = (id) => axiosInstance.delete(`${M}/vendors/${id}`);

/* ---------------- Vendor coverage: served sub-categories + brands per sub-category ---------------- */
// The sub-categories a vendor serves (each is a material_category row with a parent).
export const getVendorSubcategories = (vendorId) =>
  axiosInstance.get(`${M}/vendors/${vendorId}/subcategories`);
// Replace-set the served sub-categories. materialCategoryIds: number[]
export const setVendorSubcategories = (vendorId, materialCategoryIds) =>
  axiosInstance.put(`${M}/vendors/${vendorId}/subcategories`, { materialCategoryIds });
// Replace-set the brands stocked for one served sub-category. materialBrandIds: number[]
export const setVendorSubcategoryBrands = (vendorId, vendorSubcategoryId, materialBrandIds) =>
  axiosInstance.put(
    `${M}/vendors/${vendorId}/subcategories/${vendorSubcategoryId}/brands`,
    { materialBrandIds }
  );
